import merge from 'lodash/merge'
import common from './config.common'
import production from './config.production'
import development from './config.development'
import type { Config } from './config.type'

const configs = {
  common,
  production,
  development,
  staging: development,
  preview: development,
}

type ConfigEnv = keyof typeof configs

const isConfigEnv = (value: string | undefined): value is ConfigEnv => {
  return Boolean(value && value in configs)
}

const getRuntimeEnv = (): ConfigEnv => {
  const explicitEnv = import.meta.env.REACT_APP_NODE_ENV
  const vercelEnv = import.meta.env.VITE_VERCEL_ENV || __APP_ENV__

  if (isConfigEnv(explicitEnv)) return explicitEnv
  if (isConfigEnv(vercelEnv)) return vercelEnv

  return import.meta.env.PROD ? 'production' : 'development'
}

export const env = getRuntimeEnv()

export const isProd = () => env === 'production'

export type DeepPartial<T> = T extends object
  ? {
      [P in keyof T]?: DeepPartial<T[P]>
    }
  : T

const getConf = () => {
  if (!(env in configs)) {
    return common
  }
  return configs[env]
}

const config: Config = merge(common, getConf())

export default config
